import { WechatConversationDataType } from "../../types";
import EventBus from "../event-bus";
const conversationChangeHook = new EventBus<WechatConversationDataType>(
  "conversationChangeHook"
);

export default conversationChangeHook;
